import { currencyPrecision } from 'app/helpers/money';

export const isBlank = (str: string): boolean => !str || /^\s*$/.test(str);

export const roundAmount = (v: string | number, currency: string): number =>
  parseFloat(Number(v).toFixed(currencyPrecision(currency)));
